const MILLISECONDS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
const MINUTES_PER_HOUR = 60

function pad(value) {
    return String(value).padStart(2, '0')
}

export function formatViewingDuration(milliseconds) {
    const totalSeconds = Math.floor((milliseconds ?? 0) / MILLISECONDS_PER_SECOND)
    const seconds = totalSeconds % SECONDS_PER_MINUTE
    const totalMinutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE)
    const minutes = totalMinutes % MINUTES_PER_HOUR
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR)

    if (hours > 0) {
        return `${hours}:${pad(minutes)}:${pad(seconds)}`
    }

    return `${minutes}:${pad(seconds)}`
}
